"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "tartiffs",
    path: "tariffs",
    component: "Tariffs"
});
let Tariffs = class Tariffs extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    onItemsChanged(...args) {
        this.$app.repo.clearCache('list_object_by_type', { parameters: { object_type: 'tariff' } });
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'tariff' } }).then(d => _.sortBy(d, 'id'));
    }
    ux;
    b_7315092382398562_modalBindings;
    b_1040167445267876_rowTemplate;
    b_1040167445267876_columns;
    b_1040167445267876_style;
    dataMembers = ['items', 'ux', 'b_7315092382398562_modalBindings', 'b_1040167445267876_rowTemplate', 'b_1040167445267876_columns', 'b_1040167445267876_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_1040167445267876_rowTemplate: {
                    object_type: "tariff",
                },
                b_1040167445267876_columns: [{
                        name: "code",
                        header: this.$fn.pgettext("Tariff", "Code"),
                        width: "80px",
                        required: true,
                    },
                    {
                        name: "name",
                        header: this.$fn.pgettext("Tariff", "Name"),
                        width: "200px",
                        required: true,
                    },
                    {
                        name: "description",
                        header: this.$fn.pgettext("Tariff", "Description"),
                    },
                ],
                b_1040167445267876_style: {
                    minHeight: "200px",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("Tariffs|Header", "Configure tariffs"),
                ],
                icon: this.$config.tariff.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2964_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_script_2968_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('object_by_type').upsert($event.data.row).then(this.onItemsChanged));
    }
    async act_1040167445267876_script_2968_getActionArgs($event) {
        return {
            value: () => this.act_1040167445267876_script_2968_getActionArgs_value($event),
        };
    }
    async evh_1040167445267876_save(event, scope) {
        return await this.actions.evh_1040167445267876_save.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_script_2970_getActionArgs_value($event) {
        $event.data.waitFor(this.$fn.crud('object_by_type').delete($event.data.row).then(this.onItemsChanged));
    }
    async act_1040167445267876_script_2970_getActionArgs($event) {
        return {
            value: () => this.act_1040167445267876_script_2970_getActionArgs_value($event),
        };
    }
    async evh_1040167445267876_delete(event, scope) {
        return await this.actions.evh_1040167445267876_delete.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2964 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2964_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2963 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2964,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2963],
        });
        const act_2248226175642056_closeModal_2966 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_2965 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_2966,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2965],
        });
        const act_1040167445267876_script_2968 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1040167445267876_script_2968_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_save_2967 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_script_2968,
            event: "save",
            displayName: "script",
        });
        const evh_1040167445267876_save = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_save_2967],
        });
        const act_1040167445267876_script_2970 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1040167445267876_script_2970_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_delete_2969 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_script_2970,
            event: "delete",
            displayName: "script",
        });
        const evh_1040167445267876_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_delete_2969],
        });
        const act_1548630417156826_closeComponent_2972 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_2971 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_2972,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_2971],
        });
        return {
            act_7315092382398562_closeModal_2964,
            evh_7315092382398562_close_2963,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_2966,
            evh_2248226175642056_close_2965,
            evh_2248226175642056_close,
            act_1040167445267876_script_2968,
            evh_1040167445267876_save_2967,
            evh_1040167445267876_save,
            act_1040167445267876_script_2970,
            evh_1040167445267876_delete_2969,
            evh_1040167445267876_delete,
            act_1548630417156826_closeComponent_2972,
            evh_1548630417156826_clickPreventStop_2971,
            evh_1548630417156826_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], Tariffs.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Tariffs.prototype, "onSize", null);
Tariffs = __decorate([
    (0, vue_property_decorator_1.Component)()
], Tariffs);
exports.default = Tariffs;
vue_property_decorator_1.Vue.component("Tariffs", Tariffs);
